import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { flowGradeColour } from "../constants/flowPresentation";
import { MOTION_DURATION, MOTION_EASE } from "../../../shared/constants/motion";

const circumference = 2 * Math.PI * 72;

export default function FlowOverview({ grades, coreData, total, completed }) {
  const reduceMotion = useReducedMotion();
  const colour = flowGradeColour(total / 45 * 7);
  return (
    <div className="flow-overview" aria-label="Live score overview" data-nosnippet="true">
      <svg className="overview-ring" viewBox="0 0 180 180" role="img" aria-label={`${total} of 45 points`}>
        <circle cx="90" cy="90" r="72" fill="none" stroke="var(--ui-line)" strokeWidth="5" />
        <motion.circle cx="90" cy="90" r="72" fill="none" stroke={colour} strokeWidth="5" strokeLinecap="round" strokeDasharray={circumference} transform="rotate(-90 90 90)" initial={reduceMotion ? false : { strokeDashoffset: circumference }} animate={{ strokeDashoffset: circumference * (1 - Math.min(45, Math.max(0, total)) / 45) }} transition={{ duration: reduceMotion ? 0 : MOTION_DURATION.chart, ease: MOTION_EASE.snap }} />
        <text x="90" y="90" textAnchor="middle" className="overview-score" fill={completed || coreData.corePoints != null ? colour : "#9ca3af"}>{total}</text>
        <text x="90" y="115" textAnchor="middle" className="overview-out-of">/ 45</text>
      </svg>
      <div className="overview-groups">
        {["1", "2", "3", "4", "5", "6"].map(id => <a key={id} href={`#g${id}`} aria-label={`Jump to Group ${id}`}><span>G{id}</span><strong style={{ color: grades[id]?.grade != null ? flowGradeColour(grades[id].grade) : "#9ca3af" }}>{grades[id]?.grade ?? "--"}</strong></a>)}
        <a href="#core-title" aria-label="Jump to Core"><span>Core</span><strong style={{ color: coreData.corePoints != null ? flowGradeColour(coreData.corePoints / 3 * 7) : "#9ca3af" }}>{coreData.corePoints == null ? "--" : `+${coreData.corePoints}`}</strong></a>
      </div>
      <p className="overview-caption"><span>Estimated diploma score</span>{completed} of 6 subjects complete</p>
    </div>
  );
}
